import { Component, Prop, Vue } from "vue-property-decorator";
import { itiHttpService} from '@/iti-core-vue';
import Post from '../../../components/forum/post/post.component.vue'; 
import postModule from '../../../store/modules/post.module';
import SearchBar from '../../../components/forum/search-bar/search-bar.component.vue'
import { API } from "@/shared/api";
import collaborativeAreaModule from "@/store/modules/collaborative-area.module";

@Component({
  components: {
    Post,
    SearchBar,
  }
})
export default class ForumLayout extends Vue {
  @Prop() public ambitId!: number;
  public collaborativeName: string = '';

  public created() {
    postModule.getPosts(this.ambitId);
    collaborativeAreaModule.getCollaborativeAreaById(Number.parseInt(this.ambitId.toString()));
  }

  public get posts() {
    return postModule.postsSearched;
  }

  public addPost() {
    this.$router.push('/main/foro/' + this.ambitId + '/form');
  }

  public goToAreaHome() {
    this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: this.collaborativeArea.id.toString() } });
  } 

  public get collaborativeArea() {
    return collaborativeAreaModule.selectedCollaborativeArea;
  }
}
